import { render, staticRenderFns } from "./ModalPaymentCategoryPromo.vue?vue&type=template&id=28e65b48&scoped=true"
import script from "./ModalPaymentCategoryPromo.vue?vue&type=script&lang=js"
export * from "./ModalPaymentCategoryPromo.vue?vue&type=script&lang=js"
import style0 from "./ModalPaymentCategoryPromo.vue?vue&type=style&index=0&id=28e65b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e65b48",
  null
  
)

export default component.exports